import { concat, pick } from "ramda";

// Redux Prefix
const prefix = concat("BILLING:");

const SET_SPREEDLY_KEY = prefix("SET_SPREEDLY_KEY");
const SET_SPREEDLY_TOKEN = prefix("SET_SPREEDLY_TOKEN");
const SET_SPREEDLY_ERRORS = prefix("SET_SPREEDLY_ERRORS");

const INITIAL_STATE = {
  spreedlyKey: "",
  spreedlyToken: "",
  spreedlyErrors: "",
};

// Actions
export const setSpreedlyErrorsAction = (errors) => ({
  type: SET_SPREEDLY_ERRORS,
  payload: {
    errors,
  },
});

export const setSpreedlyKeyAction = (spreedlyKey) => ({
  type: SET_SPREEDLY_KEY,
  payload: {
    spreedlyKey,
  },
});

export const setSpreedlyTokenAction = (spreedlyToken) => ({
  type: SET_SPREEDLY_TOKEN,
  payload: {
    spreedlyToken,
  },
});

// Reducer
export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_SPREEDLY_KEY:
      return {
        ...state,
        spreedlyKey: action.payload.spreedlyKey,
      };
    case SET_SPREEDLY_TOKEN:
      return {
        ...state,
        spreedlyToken: action.payload.spreedlyToken,
      };
    case SET_SPREEDLY_ERRORS:
      return {
        ...state,
        spreedlyErrors: action.payload.errors,
      };
    default:
      return state;
  }
}
